import { WORK_DAY_HOURS_MAX, WORK_DAY_RATE_MAX, WORK_DAY_TASK_MAX_LENGTH, WORK_DAY_TASKS_MAX, workDayHours, workDayRate, workDayTasks } from "@shyne/shared/api";

export type BulkDayFigures = { payment: number | null; maxHours: number | null; tasks: string[] };

export function workDayLimitErrors(rowIndex: number, { payment, maxHours, tasks }: BulkDayFigures): string[] {
  const errors: string[] = [];
  if (payment !== null && !workDayRate.safeParse(payment).success) errors.push(`Row ${rowIndex}: Payment must be from 0 to ${WORK_DAY_RATE_MAX} with at most two decimal places.`);
  if (maxHours !== null && !Number.isNaN(maxHours) && !workDayHours.safeParse(maxHours).success) errors.push(`Row ${rowIndex}: max_hours must be more than 0 and at most ${WORK_DAY_HOURS_MAX}.`);
  if (!workDayTasks.safeParse(tasks).success) errors.push(`Row ${rowIndex}: The service's task template must have at most ${WORK_DAY_TASKS_MAX} tasks, none blank or over ${WORK_DAY_TASK_MAX_LENGTH} characters.`);
  return errors;
}
